import { render, staticRenderFns } from "./OrgaHasNoTemplateBanner.vue?vue&type=template&id=59ce9288&"
import script from "./OrgaHasNoTemplateBanner.vue?vue&type=script&lang=ts&"
export * from "./OrgaHasNoTemplateBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports